import { render, staticRenderFns } from "./ar-AE.vue?vue&type=template&id=7a10f1a2&"
import script from "./ar-AE.vue?vue&type=script&lang=js&"
export * from "./ar-AE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a10f1a2')) {
      api.createRecord('7a10f1a2', component.options)
    } else {
      api.reload('7a10f1a2', component.options)
    }
    module.hot.accept("./ar-AE.vue?vue&type=template&id=7a10f1a2&", function () {
      api.rerender('7a10f1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/ar-AE.vue"
export default component.exports